import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { TeamMapper } from "./team.mapper";

import { Team } from "./team.model";
import { environment } from "environments/environment";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";

@Injectable()
export class TeamRepository extends CrudAbstractRepository {
  getMapper(): any {
    return TeamMapper.map;
  }

  getEndpoint(): string {
    return "team";
  }

  public listByOrganization(organizationId: number): Observable<Team[]> {
    return this.http
      .get<object[]>(
        `${environment.apiUrl}/organization/${organizationId}/team/list`,
      )
      .pipe(map((response) => response.map(this.getMapper())));
  }
}
